import { Injectable, Output, Input, EventEmitter } from '@angular/core';

import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'



export interface ISubCategorias extends IDataModel {
    categoria: Number,
    codigo: Number,
    texto?: string,
    img?: string,
}

export class SubCategorias extends DataModel<ISubCategorias>  {
    categoria:Number;
    constructor(private db: AngularFirestore, private ACategoria: Number) {
        super(db, 'subCategorias');
        this.categoria = ACategoria;
    }

    @Input()
    set verInativo(x){
       this.fVerInativo = x;
       this.snapshotChanges(); 
    }

    snapshotChanges() {
        console.log(this.categoria)
        if (this.categoria > 0) {
            this.reset(
                r => r.where('categoria', '==', Number(this.categoria) )
                    .where('inativo', '==', this.fVerInativo)
            );
        } else {
            this.reset(
                r => r.where('inativo', '==', this.fVerInativo));
        }
       return super.snapshotChanges();
    }

    gerarNovoCodigo(categoria,proc){
        this.getNewID('codigo_categoria_sub_'+categoria,proc);
    }

    updateOrInsert(id,item,proc,err){
        var old = id;
        item.id = item.categoria+":"+item.codigo;
        return super.updateOrInsert(item.id,item,r=>{
            if (old && (old!==item.id))
               this.deleteRow(old);
            if (proc) proc(r);
        },err);
    }

}
